

export type ExportCompressionAlgorithm =
    "Zstd"
    | "Gzip";